<template>
  <v-app>
    <v-container class="pa-6 ma-0 d-flex flex-column gap-6 align-center main-d">
      <!-- section 1 -->
      <v-container class="pa-0 ma-0">
        <CostsFilter
          @apply-filters="HandleApplyFilters"
          @apply-advanced-filters="HandleApplyAdvancedFilters"
        />
        <OverviewCosts
          :filter-chart="filter"
          :advance-filter="advancefilter"
          :duration="changeDurationText"
        />
      </v-container>
      <!--section 2 -->
      <v-container fluid class="pa-0 ma-0">
        <v-row dense>
          <!--costs progress -->
          <v-col cols="12" md="6">
            <ProgressCosts :filter-chart="filter" :advance-filter="advancefilter" />
          </v-col>
          <!-- costs donate-->
          <v-col cols="12" md="6">
            <CostsDonate :filter-chart="filter" :advance-filter="advancefilter" />
          </v-col>
        </v-row>
      </v-container>
      <!--section 3 -->
      <v-container class="pa-0 ma-0">
        <CostsByCategory :filter-chart="filter" :advance-filter="advancefilter" />
      </v-container>
    </v-container>
  </v-app>
</template>

<script>
import CostsFilter from "./partial/CostsFilter.vue";
import OverviewCosts from "./partial/OverviewCosts.vue";
import ProgressCosts from "./partial/ProgressCosts.vue";
import CostsDonate from "./partial/CostsDonate.vue";
import CostsByCategory from "./partial/CostsByCategory.vue";

export default {
  name: "costs",
  components: {
    CostsFilter,
    OverviewCosts,
    ProgressCosts,
    CostsDonate,
    CostsByCategory,
  },
  data: () => ({
    loading: false,
    filter: null,
    advancefilter: null,
    changeDurationText: false,
  }),
  mounted() {
    this.getCostData();
  },
  methods: {
    HandleApplyFilters(filters) {
      this.filter = filters;
      this.getCostData(filters);
    },
    HandleApplyAdvancedFilters(filters) {
      this.advancefilter = filters;
      this.getCostData(filters);
    },
    getCostData(filters = {}) {
      const hasDefaultDate = !!filters.fromDate && !!filters.toDate;
      const Type = hasDefaultDate ? false : "month";
      let UserList = [];
      let ProductList = [];
      if (
        filters.UserList != undefined &&
        filters.UserList != null &&
        filters.UserList != []
      ) {
        UserList = filters?.UserList.map((u) => u.id);
      }
      if (
        filters.products != undefined &&
        filters.products != null &&
        filters.products != []
      ) {
        ProductList = filters?.products.map((p) => p.id);
      }
      var app = this;
      app.loading = true;
      this.$axios
        .get(this.$endpoint + "dashboard/invoice-kpi", {
          params: {
            dateType: Type,
            fromDate: filters.fromDate || null,
            toDate: filters.toDate || null,
            status: filters.sellStatus || [],
            accountIds: filters.account || [],
            branch: filters.branch || [],
            UserList: UserList || [],
            minAmount: filters.amountRange?.[0] ?? null,
            maxAmount: filters.amountRange?.[1] ?? null,
            ProductList: ProductList || [],
            productGroup: filters.productGroup || null,
            entrepot: filters.entrepot || null,
            attachment: filters.attachments || null,
            receipt: filters.Receipt || null,
            category: filters.category || null,
            minAmountTax: filters.amountRangeTax?.[0] ?? null,
            maxAmountTax: filters.amountRangeTax?.[1] ?? null,
            invoice_status: filters.status || null,
          },
        })
        .then((response) => {
          let res = response.data;
          app.changeDurationText = res.flag;
        })
        .catch((err) => {
          app.loading = false;
        })
        .finally(() => {
          app.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.main-d {
  min-width: 400px !important;
}
</style>
